import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'IngredientsListfilter'
})

export class FilterPipeIngredients implements PipeTransform {
    transform(ingredients: any, term?: any): any {
        if (term === undefined) return ingredients;
        if (term === null) return ingredients;

        if (ingredients != null) {
            return ingredients.filter(function (ingredient) {
                if (ingredient.name != undefined)
                    if (ingredient.name.toLowerCase().includes(term.toLowerCase()))
                        return ingredient;
                if (ingredient.price_static != undefined)
                    if (ingredient.price_static.toString().toLowerCase().includes(term.toLowerCase()))
                        return ingredient;
                if (ingredient.measurement != undefined)
                    if (ingredient.measurement.toString().toLowerCase().includes(term.toLowerCase()))
                        return ingredient;
                if (ingredient.stock != undefined)
                    if (ingredient.stock.toString().toLowerCase().includes(term.toLowerCase()))
                        return ingredient;
                if (ingredient.stock_alert != undefined)
                    if (ingredient.stock_alert.toString().toLowerCase().includes(term.toLowerCase()))
                        return ingredient;
                if (ingredient.tags_static != undefined)
                    if (ingredient.tags_static.toString().toLowerCase().includes(term.toLowerCase()))
                        return ingredient;
                if (ingredient.tags != undefined)
                    if (ingredient.tags.toString().toLowerCase().includes(term.toLowerCase()))
                        return ingredient;
            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-list/filter.pipe.ts